import "./Footer.scss";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaInstagram } from "react-icons/fa";
import useModalA11y from "../../hooks/useModalA11y";

export default function Footer() {
	const [activeModal, setActiveModal] = useState(null);
	const { t } = useTranslation();
	const closeModal = useCallback(() => setActiveModal(null), []);
	const modalRef = useModalA11y(Boolean(activeModal), closeModal);

	return (
		<footer id="footer" className="footer">
			<div className="container">
				<div className="footer__top">
					<div className="footer__brand">
						<h3>Revibrain™</h3>
						<p>{t("footer.brandText")}</p>
					</div>

					<div className="footer__links">
						<h4>{t("footer.documents")}</h4>

						<button onClick={() => setActiveModal("privacy")}>
							{t("footer.privacy")}
						</button>

						<button onClick={() => setActiveModal("terms")}>
							{t("footer.terms")}
						</button>

						<button onClick={() => setActiveModal("returns")}>
							{t("footer.returns")}
						</button>
					</div>

					<div className="footer__contacts">
						<h4>{t("footer.contacts")}</h4>

						<a href="mailto:revibrainua@gmail.com">revibrainua@gmail.com</a>

						<a
							href="https://instagram.com/revibrain"
							target="_blank"
							rel="noopener noreferrer"
							className="footer__instagram">
							<FaInstagram size={18} />
							<span>Instagram</span>
						</a>
					</div>
				</div>

				{activeModal && (
					<div className="modal-overlay" onClick={closeModal}>
						<div
							ref={modalRef}
							className="modal-content"
							role="dialog"
							aria-modal="true"
							aria-labelledby="footerModalTitle"
							tabIndex={-1}
							onClick={(e) => e.stopPropagation()}>
							<button className="modal-close" aria-label="Close" onClick={closeModal}>
								×
							</button>

							{activeModal === "privacy" && (
								<>
									<h2 id="footerModalTitle">{t("footer.privacyModal.title")}</h2>

									<p>{t("footer.privacyModal.intro")}</p>

									<p>{t("footer.privacyModal.usageTitle")}</p>

									<ul>
										{t("footer.privacyModal.items", {
											returnObjects: true,
										}).map((item, index) => (
											<li key={index}>{item}</li>
										))}
									</ul>

									<p>{t("footer.privacyModal.note")}</p>
								</>
							)}

							{activeModal === "terms" && (
								<>
									<h2 id="footerModalTitle">{t("footer.termsModal.title")}</h2>

									<p>{t("footer.termsModal.intro")}</p>

									<p>{t("footer.termsModal.usageTitle")}</p>

									<ul>
										{t("footer.termsModal.items", {
											returnObjects: true,
										}).map((item, index) => (
											<li key={index}>{item}</li>
										))}
									</ul>

									<p>{t("footer.termsModal.note1")}</p>

									<p>{t("footer.termsModal.note2")}</p>
								</>
							)}

							{activeModal === "returns" && (
								<>
									<h2 id="footerModalTitle">{t("footer.returnsModal.title")}</h2>

									<h3>{t("footer.returnsModal.generalTitle")}</h3>

									<p>{t("footer.returnsModal.generalText1")}</p>
									<p>{t("footer.returnsModal.generalText2")}</p>
									<p>{t("footer.returnsModal.generalText3")}</p>

									<h3>{t("footer.returnsModal.returnRightsTitle")}</h3>

									<p>{t("footer.returnsModal.returnRightsText")}</p>

									<ul>
										{t("footer.returnsModal.returnRightsItems", {
											returnObjects: true,
										}).map((item, index) => (
											<li key={index}>{item}</li>
										))}
									</ul>

									<h3>{t("footer.returnsModal.limitationsTitle")}</h3>

									<p>{t("footer.returnsModal.limitationsText")}</p>

									<p>{t("footer.returnsModal.limitationsListTitle")}</p>

									<ul>
										{t("footer.returnsModal.limitationsItems", {
											returnObjects: true,
										}).map((item, index) => (
											<li key={index}>{item}</li>
										))}
									</ul>

									<h3>{t("footer.returnsModal.defectTitle")}</h3>

									<p>{t("footer.returnsModal.defectText")}</p>

									<ul>
										{t("footer.returnsModal.defectItems", {
											returnObjects: true,
										}).map((item, index) => (
											<li key={index}>{item}</li>
										))}
									</ul>

									<p>{t("footer.returnsModal.defectEvidenceTitle")}</p>

									<ul>
										{t("footer.returnsModal.defectEvidenceItems", {
											returnObjects: true,
										}).map((item, index) => (
											<li key={index}>{item}</li>
										))}
									</ul>

									<p>{t("footer.returnsModal.defectNote")}</p>

									<h3>{t("footer.returnsModal.refundTitle")}</h3>

									<p>{t("footer.returnsModal.refundText1")}</p>

									<p>{t("footer.returnsModal.refundText2")}</p>

									<h3>{t("footer.returnsModal.shippingTitle")}</h3>

									<ul>
										{t("footer.returnsModal.shippingItems", {
											returnObjects: true,
										}).map((item, index) => (
											<li key={index}>{item}</li>
										))}
									</ul>

									<h3>{t("footer.returnsModal.contactTitle")}</h3>

									<p>{t("footer.returnsModal.contactText")}</p>

									<p>Email: revibrainua@gmail.com</p>

									<h3>{t("footer.returnsModal.warningTitle")}</h3>

									<p>{t("footer.returnsModal.warningText1")}</p>

									<p>{t("footer.returnsModal.warningText2")}</p>
								</>
							)}
						</div>
					</div>
				)}

				<div className="footer__bottom">
					© {new Date().getFullYear()} Revibrain™. All rights reserved.
				</div>
			</div>
		</footer>
	);
}
